export default "__VITE_ASSET__DEX7lv7G__"